export const pagesMetiersEndpoints = {
  getPage: (pageId: number) => `/api/thematicinformation/pages/${pageId}`,
  getRelatedPages: (parentId: number) => `/api/thematicinformation/relatedpages/${parentId}`,
};
